module.exports = __webpack_public_path__ + "img/ltkseasonal-3x.9ac53ab.jpg";